
import { butter } from "../plugins/buttercms";
import OccationSelector from "~/components/filter-section/cal-occation-selection.vue";
import { getDateSuffix } from "~/utils/locale";

export default {
  name: "cal-card-message-generator",
  components: { OccationSelector },
  data() {
    return {
      occasions: [],
      pageData: {},
      relationships: [],
      occasion: "",
      relationship: "",
      firstName: "",
      signature: this.$store.state.cartItem.cardSignature,
      isDisableBtn: true,
      cardMessage:
        this.$store.state.cartItem.cardMessages[
          this.getMessageKeyName(this.cardIndex)
        ] || "",
      responseCounter: -1,
      msgMaxCharacters: 900,
      remainingMsgChars: 900,
      isAiMessageLoading: false,
    };
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  async created() {
    if (this.$store.state.cartItem.occasion !== "") {
      this.occasion = this.$store.state.cartItem.occasion;
    } else {
      this.occasion = sessionStorage.occasion || "";
    }
    if (this.$store.state.cartItem.recipient.relationship !== "") {
      this.relationship = this.$store.state.cartItem.recipient.relationship;
    } else {
      this.relationship = "";
    }
    await this.getOccasionsList();
    this.getRelationshipList();
    this.firstName = this.$store.state.cartItem.recipient.firstName || "";
    this.validateMessageDetails();

    if (this.signature && this.signature.length > 0) {
      this.validateMessageDetails();
      this.handleSignatureUpdate();
      let updatedMsg = this.removeSignature(this.cardMessage);
      this.cardMessage = `${updatedMsg}\n- ${this.signature}`;
      this.setRemainingChars();
    }

    this.$nuxt.$on("relationshipUpdated", () => {
      if (this.$store.state.cartItem.recipient.relationship !== "") {
        this.relationship = this.$store.state.cartItem.recipient.relationship;
        this.validateMessageDetails();
      }
    });

    this.$nuxt.$on("occasionSelected", () => {
      this.occasion = sessionStorage.occasion || "";
      this.validateMessageDetails();
    });

    this.$nuxt.$on("firstNameUpdated", () => {
      this.firstName = this.$store.state.cartItem.recipient.firstName;
      this.validateMessageDetails();
    });

  },
  watch: {
    cardMessage() {
      if (
        this.cardMessage &&
        this.cardMessage.length > 0 &&
        this.signature &&
        this.signature.length > 0
      ) {
        let updatedMsg = this.removeSignature(this.cardMessage);
        this.cardMessage = `${updatedMsg}\n- ${this.signature}`;
        this.$nuxt.$emit("updateCardMessage", this.cardMessage, this.cardIndex);
        this.setRemainingChars();
      }
    },
    signature() {
      this.validateMessageDetails();
      this.handleSignatureUpdate();
      let updatedMsg = this.removeSignature(this.cardMessage);
      this.cardMessage = `${updatedMsg}\n- ${this.signature}`;
      if (this.signatureStr != this.signature) {
        //emiting for all to be updated
        this.$emit("updatedSignature", this.signature);
      }
    },
    relationship() {
      this.validateMessageDetails();
      this.$store.dispatch("cartItem/SET_RELATIONSHIP", this.relationship);
      if (this.relationshipStr != this.relationship) {
        //emiting for all to be updated
        this.$emit("updatedRelationship", this.relationship);
      }
    },
    relationshipStr() {
      this.relationship = this.relationshipStr;
    },
    signatureStr() {
      this.signature = this.signatureStr;
    },
    occasion() {
      this.validateMessageDetails();
      this.$emit("updatedOccasion", this.occasion, this.cardIndex);
    },
  },
  props: {
    cardIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    isSubscription: {
      type: Boolean,
      required: true,
      default: false,
    },
    subscriptionDeliveryDates: {
      type: Array,
      required: false,
      default: () => [],
    },
    relationshipStr: {
      type: String,
      required: false,
      default: "",
    },
    signatureStr: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    removeSignature(msg) {
      const separator = "\n- ";
      const index = msg.lastIndexOf(separator);
      if (index !== -1) {
        return msg.substring(0, index);
      }
      return msg;
    },
    getMessageKeyName(i) {
      return this.isSubscription
        ? `${i + 1}${this.getDateSuffix(i)} Message`
        : "Message";
    },
    getSignatureKeyName(i) {
      return this.isSubscription
        ? `${i + 1}${this.getDateSuffix(i)} Signature`
        : "Signature";
    },
    getDateSuffix(index) {
      return getDateSuffix(this.$i18n.locale, index + 1, true);
    },
    setRemainingChars() {
      if (this.cardMessage && this.cardMessage.length > 0) {
        this.remainingMsgChars =
          this.msgMaxCharacters - this.cardMessage.length;
      } else {
        this.remainingMsgChars = this.msgMaxCharacters;
      }
    },
    getCardMessage(generatedMessage) {
      this.handleMessage(generatedMessage);
    },
    cardMessageLoading(isCardMessageLoading) {
      this.isAiMessageLoading = isCardMessageLoading;
    },
    handleMessage(message) {
      // Replace '"' for avoid bad Unicode escape sequence issue
      message?.replaceAll(/"/g, '"\u200B');
      message = message?.replace(/"/g, "");
      this.$nuxt.$emit("updateCardMessage", message, this.cardIndex);
      this.setRemainingChars();
    },
    handleSignatureUpdate() {
      this.$nuxt.$emit("updateCardSignature", this.signature, this.cardIndex);
    },
    async getOccasionsList() {
      try {
        const response = await butter(this.$config).content.retrieve(
          ["occasions"],
          { locale: this.$i18n.locale, timeout: 10000 }
        );
        this.occasionsHeader =
          response?.data.data["occasions"][0]["occasion-header"];
        this.occasions = response?.data.data["occasions"][0]["occasion-types"];
        this.occasions = this.occasions.map(
          (occasion) => occasion["occasion-name"]
        );
      } catch (error) {
        console.error(error);
      }
    },
    async getRelationshipList() {
      try {
        const page = await butter(this.$config).page.retrieve(
          "recipient_details",
          "recipient-details",
          {
            locale: this.$i18n.locale,
            timeout: 10000,
          }
        );
        this.pageData = page?.data.data.fields;
        this.generateRelationshipsArray();
      } catch (error) {
        console.error(error);
      }
    },
    generateRelationshipsArray() {
      const arr = this.pageData["relationships-array"].split(",");
      this.relationships = [];
      if (arr && arr.length > 0) {
        arr.forEach((item) => {
          this.relationships.push(item.trim());
        });
      }
    },
    async generateText() {
      try {
        if (this.occasion && this.relationship && this.firstName) {
          this.$emit("cardMessageLoading", true);
          let relationshipParam = "";
          let occasionParam = "";
          if (this.$i18n.locale === "fr-ca") {
            occasionParam = this.getOccasionParam();
            relationshipParam = this.getRelationshipParam();
          } else {
            relationshipParam = this.relationship;
            occasionParam = this.occasion;
          }
          this.responseCounter++;
          if (this.responseCounter < -1 || this.responseCounter > 2) {
            this.responseCounter = 0;
          }

          const params = {
            occasion: occasionParam.replace(/\s/g, ""),
            relationship: relationshipParam.replace(/\s/g, ""),
            firstName: this.firstName,
            signature: this.signature || "",
            responseCounter: this.responseCounter,
          };
          const response = await this.$axios.get(`card/message/generation`, {
            params,
            headers: { "callia-lang": this.$i18n.locale },
          });
          this.cardMessage = response.data;
          if (this.cardMessage) {
            this.cardMessageLoading = false;
          }
        }
      } catch (error) {
        this.cardMessageLoading = false;
        this.$emit("cardMessageLoading", false);
        console.log(error);
      }
    },
    validateMessageDetails() {
      if (
        this.occasion &&
        this.relationship &&
        this.firstName &&
        !/^\s+$/.test(this.firstName)
      ) {
        this.isDisableBtn = false;
      } else {
        this.isDisableBtn = true;
      }
    },
    getOccasionParam() {
      const frenchOccasionMap = {
        "Temps des fêtes": "holidays",
        Anniversaire: "anniversary",
        Remerciemens: "thankyou",
        Célébration: "celebration",
        Fiançailles: "engagement",
        "Simplement parce que": "justbecause",
        Sympathies: "sympathy",
      };
      return frenchOccasionMap[this.occasion] || "other";
    },
    getRelationshipParam() {
      const frenchRelationshipMap = {
        "Moi-même": "myself",
        Partenaire: "partner",
        Maman: "mom",
        Ami: "friend",
        "Grand-parent": "grandparent",
      };
      return frenchRelationshipMap[this.relationship] || this.relationship;
    },
  },
};
